export default "__VITE_ASSET__BkgskXAh__"